import Events from "actions/events";
let _error=Symbol("error");

export class ErrorHandlerStore {

  constructor(){
    this[_error] = null;
    this.loadError = this.loadError.bind(this);
    this.errorHandlerReducer = this.errorHandlerReducer.bind(this);
  }
  errorHandlerReducer(state, action) {

    this.loadError(action)
    return this;
  }
  loadError(action) {
    switch(action.type){
      case Events.ErrorHandler.ERROR :
        console.log('ERROR LOGGED');
        this[_error] = action.data
        break;
      case Events.ErrorHandler.CLEAR_ERROR :
        this[_error] = null;
        break;
      default :
        return;
    }
  }
  get error() {
    return this[_error];
  }

}

let store = new ErrorHandlerStore();
let ErrorReducer = store.errorHandlerReducer;
export default ErrorReducer;



// WEBPACK FOOTER //
// ./src/scripts/reducers/ErrorReducer.js